import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const ways = [
    {
        title: "Corporate Social Responsibility (CSR)",
        desc: "Partner with PSGS under your CSR mandate to drive measurable impact in water, sanitation, livelihood, and climate action across rural Maharashtra.",
        icon: "🤝",
    },
    {
        title: "Volunteer Your Skills",
        desc: "Contribute your professional expertise — training, technology, agriculture, health — to support our field programs and community initiatives.",
        icon: "🙋",
    },
    {
        title: "Fund a Project",
        desc: "Sponsor specific projects in watershed development, women's empowerment, organic farming, or disaster relief directly in underserved communities.",
        icon: "💰",
    },
    {
        title: "Donate Materials",
        desc: "Provide essential supplies such as seeds, saplings, educational kits, or sanitation materials to support ongoing rural development work.",
        icon: "📦",
    },
    {
        title: "Spread Awareness",
        desc: "Help amplify PSGS's mission by sharing our stories, connecting us with networks, and advocating for sustainable rural development.",
        icon: "📣",
    },
    {
        title: "Institutional Partnerships",
        desc: "Collaborate as a government body, NGO, or academic institution to co-create programs, share knowledge, and scale impact together.",
        icon: "🏛️",
    },
];

const HowToHelp = ({ darkMode }) => {
    return (
        <div style={{ paddingTop: "80px" }}>
            <div style={{
                background: "linear-gradient(135deg, #1B5E20, #388E3C, #4CAF50)",
                padding: "60px 0 50px",
                color: "#fff",
                textAlign: "center",
            }}>
                <Container>
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        style={{ fontWeight: "800", marginBottom: "16px" }}
                    >
                        How to Help
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.15 }}
                        style={{ maxWidth: "700px", margin: "0 auto", fontSize: "1.1rem", opacity: 0.92 }}
                    >
                        Every contribution — time, expertise, or resources — strengthens rural communities.
                        Discover the ways you can make a lasting difference with PSGS.
                    </motion.p>
                </Container>
            </div>

            <Container style={{ padding: "50px 0 60px" }}>
                <Row className="g-4">
                    {ways.map((w, i) => (
                        <Col md={6} lg={4} key={i}>
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: i * 0.08 }}
                            >
                                <Card className="h-100 shadow-sm" style={{
                                    border: "none",
                                    borderRadius: "12px",
                                    backgroundColor: darkMode ? "#2c3034" : "#fff",
                                }}>
                                    <Card.Body style={{ padding: "28px" }}>
                                        <div style={{ fontSize: "2.2rem", marginBottom: "12px" }}>{w.icon}</div>
                                        <Card.Title style={{
                                            fontWeight: "700",
                                            fontSize: "1.05rem",
                                            color: "#2E7D32",
                                            marginBottom: "10px",
                                        }}>
                                            {w.title}
                                        </Card.Title>
                                        <Card.Text style={{
                                            fontSize: "0.92rem",
                                            color: darkMode ? "#ccc" : "#555",
                                            lineHeight: "1.7",
                                        }}>
                                            {w.desc}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    ))}
                </Row>

                <div className="text-center" style={{ marginTop: "50px" }}>
                    <h4 style={{ fontWeight: "700", color: "#2E7D32", marginBottom: "12px" }}>
                        Ready to make a difference?
                    </h4>
                    <p style={{ fontSize: "1rem", color: "#555", maxWidth: "600px", margin: "0 auto 20px" }}>
                        Reach out to us to discuss partnership opportunities or start your contribution today.
                    </p>
                    <Link
                        to="/contact"
                        className="btn"
                        style={{
                            backgroundColor: "#2E7D32",
                            color: "#fff",
                            borderRadius: "6px",
                            padding: "10px 32px",
                            fontWeight: "600",
                            fontSize: "1rem",
                        }}
                    >
                        Contact Us →
                    </Link>
                </div>
            </Container>
        </div>
    );
};

export default HowToHelp;
